module.exports = __webpack_public_path__ + "img/warning.a5ee8289.png";